module.exports = __webpack_public_path__ + "img/event_slot_selected.29a6b7c6.svg";